import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import BookAppointmentTab from '../components/dashboard/client/BookAppointmentTab';
import { useAuth } from '../contexts/AuthContext';
import { FirebasePatientService } from '../services/firebase/FirebasePatientService';

const BookAppointment: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userProfile } = useAuth();
  const [providerId, setProviderId] = useState<string>('');
  const rescheduleAppointmentId = (location.state as any)?.rescheduleAppointmentId || null;

  // Phone OTP users have a different Firebase Auth UID — resolve to actual patient record
  const resolvedPatientId = userProfile?.patientId || user?.uid || '';
  const patientId = resolvedPatientId;
  const patientName = userProfile?.displayName || user?.displayName || 'Patient';

  useEffect(() => {
    if (patientId) {
      FirebasePatientService.getPatient(patientId).then(patient => {
        if (patient?.assignedProviderId) {
          setProviderId(patient.assignedProviderId);
        }
      }).catch(err => console.error('Failed to load patient:', err));
    }
  }, [patientId]);

  if (!user) {
    return (
      <div className="app">
        <Header />
        <main id="main-content" className="page">
          <div className="container" style={{ textAlign: 'center', paddingTop: '3rem' }}>
            <p style={{ color: '#d1d5db' }}>Please log in to book an appointment.</p>
            <button
              onClick={() => navigate('/client-login')}
              className="btn btn-primary"
              style={{ marginTop: '1rem' }}
            >
              Go to Login
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />

      <main id="main-content" className="page">
        <div className="container">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              marginBottom: '2rem'
            }}>
              <button
                onClick={() => navigate('/client-dashboard')}
                style={{
                  background: '#374151',
                  color: '#f9fafb',
                  border: 'none',
                  borderRadius: '0.5rem',
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontSize: '0.875rem'
                }}
              >
                ← Back to Dashboard
              </button>
              <h1 className="page-title">{rescheduleAppointmentId ? 'Reschedule Appointment' : 'Book Appointment'}</h1>
            </div>

            {/* Use the BookAppointmentTab component */}
            <BookAppointmentTab
              patientId={patientId}
              patientName={patientName}
              providerId={providerId}
              rescheduleAppointmentId={rescheduleAppointmentId}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default BookAppointment;
